import { QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra';
import { getDomainDataFromAccountParams, getDomainDataWithAccountParams, getUserDomain } from './searchAggregations';
import { DomainsApiConfig } from '../../apiConfigurations';
import { isResellerAggregation } from './resellerAggregations';
import { BusinessTags, ResellerCapabilities, ResellerProductTypeIds } from '../../constants';
import { getRedeemOrderPageData } from './domainRedemptionAggregations';
import { connectOrBindDomain } from './connectOrBindDomain';
import { connectedDomainSetupConfig } from './connectedDomainSetupConfig';
import { canPurchaseDomain } from './canPurchaseDomain';
import { canConnectOrBindDomain } from './canConnectOrBindDomain';
import { canTransferInDomain } from './canTransferInDomain';
import { domainsPermissions } from './domainsPermissions';
import { canPurchaseOrConnect } from './canPurchaseOrConnect';
import { isPremiumDomainQuery } from './isPremiumDomain';
import { domainSuggestionsAi } from './domainSuggestionsAi';
import { getDomainAddonLineItem, getDomainAddons, getDomainLineItem, getDomainLineItemWithAddon, upsertDomainAddonToCart, upsertDomainToCart } from './cartAggregations';
import { isVoucherSupported } from './isVoucherSupported';
import { queryInitialDomainContacts } from './domainContacts';
import { isEligibleForDomainInCart } from './isEligibleForDomainInCart';
import { canConnectOrBindDomainSuite } from './canConnectOrBindDomainSuite';
import { domainsLogger } from './domainsLogger';
import { getIsOnSale } from './getIsOnSale';
import { createMetasite } from './createMetasite';
import { getPurchasePermissions } from './getPurchasePermissions';
import { checkDomainIsTaken } from './checkDomainIsTaken';
import { canPurchaseDomainSuite } from './canPurchaseDomainSuite';
import { getWhoisAvailability } from './getWhoisAvailability';
import { getDomainAddonProducts, getDomainCycles, getRecommendedAddonProductId } from './dynamic';
export const DomainsAggregationServiceConfig = {
  baseUrl: '/'
};
export const DomainsAggregationsConfig = {
  domainsLogger: {
    name: 'domainsLogger',
    service: DomainsAggregationServiceConfig,
    queryFn: domainsLogger
  },
  getIsOnSale: {
    name: 'getIsOnSale',
    service: DomainsAggregationServiceConfig,
    queryFn: getIsOnSale
  },
  createMetasite: {
    name: 'createMetasite',
    service: DomainsAggregationServiceConfig,
    queryFn: createMetasite
  },
  getPurchasePermissions: {
    name: 'getPurchasePermissions',
    service: DomainsAggregationServiceConfig,
    queryFn: getPurchasePermissions
  },
  domainDataFromAccountParams: {
    name: 'domainDataFromAccountParams',
    service: DomainsAggregationServiceConfig,
    queryFn: getDomainDataFromAccountParams,
    keyTransform: DomainsApiConfig.domainData.keyTransform
  },
  getWhoisAvailability: {
    name: 'getWhoisAvailability',
    service: DomainsAggregationServiceConfig,
    queryFn: getWhoisAvailability
  },
  domainDataWithAccountParams: {
    name: 'domainDataWithAccountParams',
    service: DomainsAggregationServiceConfig,
    queryFn: getDomainDataWithAccountParams,
    keyTransform: req => DomainsApiConfig.domainData.keyTransform == null ? void 0 : DomainsApiConfig.domainData.keyTransform(req.domainDataRequest)
  },
  isReseller: {
    name: 'isReseller',
    service: DomainsAggregationServiceConfig,
    queryFn: isResellerAggregation
  },
  isDomainsReseller: {
    name: 'isDomainsReseller',
    service: DomainsAggregationServiceConfig,
    queryFn: async _ref => {
      let {
        httpClient,
        request
      } = _ref;
      return isResellerAggregation({
        httpClient,
        request: {
          capabilityNames: [ResellerCapabilities.ADD_RESELLER_DOMAIN],
          productTypeId: ResellerProductTypeIds.DOMAIN,
          ...request
        }
      });
    }
  },
  isRegistrar: {
    name: 'isRegistrar',
    service: DomainsAggregationServiceConfig,
    queryFn: async _ref2 => {
      let {
        httpClient,
        request
      } = _ref2;
      return isResellerAggregation({
        httpClient,
        request: {
          capabilityNames: [ResellerCapabilities.ADD_RESELLER_DOMAIN],
          productTypeId: ResellerProductTypeIds.DOMAIN,
          ...request
        }
      });
    }
  },
  getRedeemOrderPageData: {
    name: 'getRedeemOrderPageData',
    service: DomainsAggregationServiceConfig,
    queryFn: getRedeemOrderPageData
  },
  userDomain: {
    name: 'userDomain',
    service: DomainsAggregationServiceConfig,
    queryFn: getUserDomain,
    queryConfigType: QueryConfigTypes.DYNAMIC_DATA,
    tags: [BusinessTags.domainAssignment]
  },
  connectAndBindDomain: {
    name: 'connectAndBindDomain',
    service: DomainsAggregationServiceConfig,
    queryFn: connectOrBindDomain,
    queryConfigType: QueryConfigTypes.REALTIME_NO_REFETCH,
    tags: [BusinessTags.listDomains, BusinessTags.domainAssignment],
    isMutating: true
  },
  connectedDomainSetupConfig: {
    name: 'connectedDomainSetupConfig',
    service: DomainsAggregationServiceConfig,
    queryFn: connectedDomainSetupConfig,
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  canPurchaseOrConnect: {
    name: 'canPurchaseOrConnect',
    service: DomainsAggregationServiceConfig,
    queryFn: canPurchaseOrConnect,
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  canPurchaseDomain: {
    name: 'canPurchaseDomain',
    service: DomainsAggregationServiceConfig,
    queryFn: canPurchaseDomain,
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  canPurchaseDomainSuite: {
    name: 'canPurchaseDomainSuite',
    service: DomainsAggregationServiceConfig,
    queryFn: canPurchaseDomainSuite,
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  isVoucherSupported: {
    name: 'isVoucherSupported',
    service: DomainsAggregationServiceConfig,
    queryFn: isVoucherSupported,
    queryConfigType: QueryConfigTypes.FIXED_DATA
  },
  canConnectOrBindDomain: {
    name: 'canConnectOrBindDomain',
    service: DomainsAggregationServiceConfig,
    queryFn: canConnectOrBindDomain,
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  canConnectOrBindDomainSuite: {
    name: 'canConnectOrBindDomainSuite',
    service: DomainsAggregationServiceConfig,
    queryFn: canConnectOrBindDomainSuite,
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  checkDomainIsTaken: {
    name: 'checkDomainIsTaken',
    service: DomainsAggregationServiceConfig,
    queryFn: checkDomainIsTaken,
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  domainSuggestionsAi: {
    name: 'domainSuggestionsAi',
    service: DomainsAggregationServiceConfig,
    queryFn: domainSuggestionsAi,
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  canTransferInDomain: {
    name: 'canTransferInDomain',
    service: DomainsAggregationServiceConfig,
    queryFn: canTransferInDomain,
    queryConfigType: QueryConfigTypes.MODERATE_DATA
  },
  domainPermissions: {
    name: 'domainPermissions',
    service: DomainsAggregationServiceConfig,
    queryFn: domainsPermissions
  },
  isPremiumDomain: {
    name: 'isPremiumDomain',
    tags: [],
    service: DomainsAggregationServiceConfig,
    queryConfigType: QueryConfigTypes.STATIC_DATA,
    queryFn: isPremiumDomainQuery
  },
  upsertDomainToCart: {
    name: 'upsertDomainToCart',
    tags: [],
    service: DomainsAggregationServiceConfig,
    queryConfigType: QueryConfigTypes.REALTIME_NO_REFETCH,
    queryFn: upsertDomainToCart,
    isMutating: true
  },
  upsertDomainAddonToCart: {
    name: 'upsertDomainAddonToCart',
    tags: [],
    service: DomainsAggregationServiceConfig,
    queryConfigType: QueryConfigTypes.REALTIME_NO_REFETCH,
    queryFn: upsertDomainAddonToCart,
    isMutating: true
  },
  getDomainLineItem: {
    name: 'getDomainLineItem',
    tags: [],
    service: DomainsAggregationServiceConfig,
    queryConfigType: QueryConfigTypes.FIXED_DATA,
    queryFn: getDomainLineItem,
    isMutating: false
  },
  getDomainAddonLineItem: {
    name: 'getDomainAddonLineItem',
    tags: [],
    service: DomainsAggregationServiceConfig,
    queryConfigType: QueryConfigTypes.FIXED_DATA,
    queryFn: getDomainAddonLineItem,
    isMutating: false
  },
  getDomainLineItemWithAddon: {
    name: 'getDomainLineItemWithAddon',
    tags: [],
    service: DomainsAggregationServiceConfig,
    queryConfigType: QueryConfigTypes.FIXED_DATA,
    queryFn: getDomainLineItemWithAddon,
    isMutating: false
  },
  getDomainAddons: {
    name: 'getDomainAddons',
    tags: [],
    service: DomainsAggregationServiceConfig,
    queryConfigType: QueryConfigTypes.FIXED_DATA,
    queryFn: getDomainAddons,
    isMutating: false
  },
  getDomainContacts: {
    name: 'getDomainContacts',
    tags: [],
    service: DomainsAggregationServiceConfig,
    queryConfigType: QueryConfigTypes.FIXED_DATA,
    queryFn: queryInitialDomainContacts,
    isMutating: false
  },
  isEligibleForDomainInCart: {
    name: 'isEligibleForDomainInCart',
    tags: [],
    service: DomainsAggregationServiceConfig,
    queryConfigType: QueryConfigTypes.FIXED_DATA,
    queryFn: isEligibleForDomainInCart,
    isMutating: false
  },
  getRecommendedAddonProductId: {
    name: 'getRecommendedAddonProductId',
    tags: [],
    service: DomainsAggregationServiceConfig,
    queryConfigType: QueryConfigTypes.FIXED_DATA,
    queryFn: getRecommendedAddonProductId,
    isMutating: false
  },
  getDomainCycles: {
    name: 'getDomainCycles',
    tags: [],
    service: DomainsAggregationServiceConfig,
    queryConfigType: QueryConfigTypes.FIXED_DATA,
    queryFn: getDomainCycles,
    isMutating: false
  },
  getDomainAddonProducts: {
    name: 'getDomainAddonProducts',
    tags: [],
    service: DomainsAggregationServiceConfig,
    queryConfigType: QueryConfigTypes.FIXED_DATA,
    queryFn: getDomainAddonProducts,
    isMutating: false
  }
};
//# sourceMappingURL=DomainsAggregationsConfig.js.map